module.exports = {
      id: "my_account_white-usage",
      viewBox: "0 0 11 12",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#my_account_white",
      toString: function () {
        return this.url;
      }
    }